import CookiesConsent from '~/backend/cookies_consent';

const initialState = {
	necessary: true,
	preferences: CookiesConsent.preferencesConsent(),
	marketing: CookiesConsent.marketingConsent(),
	performance: CookiesConsent.performanceConsent(),
	showCookies: false
};

const cookiesReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'consent-cookies':
			state = { ...action.args };
			break;
		case 'open-cookies':
			state = { ...state, showCookies: true };
			break;
		case 'close-cookies':
			state = { ...state, showCookies: false };
			break;
		default:
			state = { ...state };
			break;
	}
	return state;
};

export default cookiesReducer;
